// action - state management
import { createSlice } from "@reduxjs/toolkit";

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const initialState = {
  isLoggedIn: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    login: (state, action) => {
      return {
        ...state,
        isLoggedIn: true,
        ...action.payload,
      };
    },
    changeSeason: (state, action) => {
      return {
        ...state,
        seasonId: action.payload.season,
      };
    },

    refreshToken: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    logout: (state) => {
      return initialState;
    },
  },
});

export const { login, refreshToken, logout, changeSeason } = authSlice.actions;

// THUNK (intermediate logout flow)
export const logoutUser = () => async (dispatch, getState) => {
  console.log("logoutUser");
  const state = getState();

  dispatch(logout());

  try {
    console.log("state.auth", state.auth);

    if (state.auth.user.authenticationProvider === "GSIS_PA") {
      const baseUrl = import.meta.env.VITE_REACT_APP_BASE_URL;
      const fullUrl = `${baseUrl}/auth/LogOutPA`;
      window.location.replace(fullUrl);
    }
  } catch (e) {
    console.error("PA logout failed", e);
  }
};

export default authSlice.reducer;
